<template>
  <div id="fillet" ref="root">
    <svg>
    </svg>
  </div>
</template>

<script>

import Fillet from '@/assets/javascripts/fillet/fillet';

export default {
  fillet: null, // this.$options.fillet
  data () {
    return {
      loaded: false,
      origin: {}
    };
  },
  mounted () {
    const root = this.$refs.root;
    this.$options.fillet = new Fillet(root);
    console.log(this.$options);
  },
  beforeDestroy () {
    this.$options.fillet.destroy();
  },
  methods: {
    load (json) {
      if (this.loaded) return;
      this.loaded = true;
      this.origin = json;
      this.$options.fillet.load(this.origin);
    },
    select (filletType) {
      if (this.$options.fillet !== null) {
        this.$options.fillet.select(filletType);
      }
    },
    all () {
      this.$options.fillet.all();
    },
    redo () {
      this.$options.fillet.redo();
    },
    undo () {
      this.$options.fillet.undo();
    },
    reset () {
      this.$options.fillet.load(this.origin);
    },
    build () {
      return this.$options.fillet.build();
    },
    serialize () {
      return this.$options.fillet.serialize();
    },
    deserialize (source) {
      return this.$options.fillet.deserialize(source);
    },
    updateMill (mill) {
      this.$options.fillet.updateMill(mill);
    }
  }
};

</script>

<style lang="scss" scoped>

#fillet {
  &.panning {
    cursor: move;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Fillet.vue